import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { Link } from 'react-router-dom';
import Typography from '@mui/material/Typography';

export default function About({ children }) {

    const url = window.location.pathname;

    return (
        <Box>
            <Grid container>
                <Grid size={4} bgcolor={'#f0f0ef'}>
                    <Grid container width={'140px'} marginLeft={'auto'} marginRight={'100px'} marginTop={'40px'}>
                        <Grid size={12}>
                            <Typography variant="body1" className='dColor' fontSize={'1.5rem'} fontWeight={'bold'} component={Link}>About</Typography>
                        </Grid>
                    </Grid>
                    <Grid container marginTop={'40px'} width={'140px'} marginLeft={'auto'} marginRight={'100px'} spacing={3}>
                        <Grid size={12}>
                            <Typography variant="body1" className='dColor' fontSize={'1.125rem'} fontWeight={url === '/contact' ? 'bold': 'regular'} component={Link} to="/contact">Contact</Typography>
                        </Grid>
                        {/* <Grid size={12}>
                            <Typography variant="body1" className='dColor' fontSize={'1.125rem'} fontWeight={url === '/careers' ? 'bold': 'regular'} component={Link} to="/careers">Careers</Typography>
                        </Grid> */}
                        <Grid size={12}>
                            <Typography variant="body1" className='dColor' fontSize={'1.125rem'} fontWeight={url === '/faq' ? 'bold': 'regular'} component={Link} to="/faq">Faq</Typography>
                        </Grid>
                        <Grid size={12}>
                            <Typography variant="body1" className='dColor' fontSize={'1.125rem'} fontWeight={url === '/results-gallery' ? 'bold': 'regular'} component={Link} to="/results-gallery">Results Gallery</Typography>
                        </Grid>
                        <Grid size={12}>
                            <Typography variant="body1" className='dColor' fontSize={'1.125rem'} fontWeight={url === '/our-story' ? 'bold': 'regular'} component={Link} to="/our-story">Our Story</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={8} marginTop={'40px'} paddingBottom={'100px'}>
                    {
                        children ??
                        <Box>
                            test
                        </Box>
                    }
                </Grid>
            </Grid>
        </Box>
    )
}